import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	voucher: {
		"&:hover": {
			textDecoration: "underline",
			textDecorationThickness: "1.5px",
			textUnderlineOffset: "2px"
		}
	}
}));

export default styles;
